// extracted by mini-css-extract-plugin
export default {"root":"RiskStatusBar_root-Y0U","label":"RiskStatusBar_label-lAx","bar":"RiskStatusBar_bar-yCG"};